import { Injectable } from '@angular/core';
import { RestApiService } from '../rest-api.service';
import { Observable } from 'rxjs/internal/Observable';


@Injectable({
  providedIn: 'root'
})
export class MemberElementDetailLinkService {

  private getMembersUrl = "ProjectMembersLink/GetMembersAgainstProjectBusinessGroup";
  private getSelectedMembersUrl = "MemberElementDetailsLink/GetMembersAgainstProjectElementDetail";
  private getSelectedModuleElementMembers = "MemberElementDetailsLink/GetMembersAgainstModuleElementDetail";
  private postProjectMembersElementDetailsUrl = "MemberElementDetailsLink/PostProjectMemberElementDetails";

  constructor(public restApiService: RestApiService,) { }

  /**
   * Get all members
   * @param groupId 
   * @param projectId 
   */
  getMembers(groupId: number, projectId: number) {
    return this.restApiService.new_POST(this.getMembersUrl, { groupId, projectId });
  }

  /**
   * Get previously selected members
   * @param projectId 
   * @param groupId 
   * @param elementId 
   * @param elementDetailedId 
   */
  getSelectedMembers(projectId: number, groupId: number, elementId: any, elementDetailedId: any, module: number): Observable<any> {
    let reqData = {
      projectId,
      groupId,
      elementId,
      elementDetailedId,
      module
    }

    return this.restApiService.new_POST(this.getSelectedMembersUrl, reqData);
  }

  getSelectedElementMembers(projectId, groupId, elementId, elementDetailedId, elementDedIdCount, module, moduleCount) {
    let reqData = {
      projectId,
      groupId,
      elementId,
      elementDetailedId,
      elementDedIdCount,
      module,
      moduleCount
    }
    return this.restApiService.new_POST(this.getSelectedModuleElementMembers, reqData);
  }

  /**
   * Save mapped member element details
   */
  postMembersElementDetails(reqData: { projectId: number; groupId: number; elementId: number; elementDetailedId: string; activeMemberIds: string | null; inactiveMemberIds: string | null; createdBy: number; }) {
    return this.restApiService.new_POST(this.postProjectMembersElementDetailsUrl, reqData);
  }
}
